import GetBrandFromManufacturer from './GetBrandFromManufacturer.js';

export default function (to, usedLandingPage) {
    let query = to.query || {};
    let meta = to.meta || {};
    if ((query.new && query.new == '1') || (meta.new && meta.new == 1)) {
        delete query.new;
        if (query.manufacturer) {
            const brandFromManufacturer = GetBrandFromManufacturer(query.manufacturer);
            if (brandFromManufacturer !== 'randd') {
                delete query.manufacturer;
                return {
                    name: 'branded-stock-search-results',
                    params: {
                        brand: brandFromManufacturer,
                    },
                    query: query,
                };
            } else {
                query.manufacturer = '';
            }
        } else if (to.params && to.params.brand) {
            if (to.params.brand !== 'randd') {
                delete query.manufacturer;
                return {
                    name: 'branded-stock-search-results',
                    params: {
                        brand: to.params.brand,
                    },
                    query: query,
                };
            }
        }
        return {
            name: 'stock-search-results',
            query: query,
        };
    }

    // Check if everything in the usedLandingPage (if it even exists) is included in the query, and if so clear out those items from the query and return the used landing page route
    if (usedLandingPage != null) {
        let everythingFound = true;
        Object.keys(usedLandingPage.query).forEach(key => {
            if (everythingFound == false) {
                return;
            }

            const landingPageQueryValue = usedLandingPage.query[key];

            if (typeof query[key] == 'undefined' && landingPageQueryValue.length > 0) {
                everythingFound = false;
                return;
            }

            // We don't want to allow a /peugeot style URL to have a Citroen added in
            if (key == 'manufacturer' && usedLandingPage.manufacturer_slug != '') {
                if (typeof query.manufacturer == 'undefined') {
                    everythingFound = false;
                    return;
                }
                let everythingFoundForThisKey = true;
                Object.keys(query.manufacturer).forEach(subKey => {
                    if (landingPageQueryValue.indexOf(query.manufacturer[subKey]) === -1) {
                        everythingFoundForThisKey = false;
                    }
                });
                if (everythingFoundForThisKey === false) {
                    everythingFound = false;
                    return;
                }
            }

            if (typeof landingPageQueryValue == 'object') {
                if (typeof query[key] == 'object') {
                    let everythingFoundForThisKey = true;
                    Object.keys(landingPageQueryValue).forEach(subKey => {
                        if (everythingFoundForThisKey === false) {
                            return;
                        }
                        if (query[key].indexOf(landingPageQueryValue[subKey]) === -1) {
                            everythingFoundForThisKey = false;
                        }
                    });
                    if (everythingFoundForThisKey === false) {
                        everythingFound = false;
                    }
                    return;
                }
                // If we get here then somehow the key should be an array but the query isn't an array. Something's definitely gone wrong
                everythingFound = false;
                return;
            }

            if (query[key] != landingPageQueryValue) {
                everythingFound = false;
            }
        });
        if (everythingFound) {
            const optimizedQuery = {};
            Object.keys(query).forEach(key => {
                // If the landing page doesn't have this key then include it
                if (typeof usedLandingPage.query[key] == 'undefined') {
                    optimizedQuery[key] = query[key];
                    return;
                }

                // If the landing page has this key, then find any values from query that aren't in the landing page query
                if (typeof query[key] == 'object') {
                    if (typeof usedLandingPage.query[key] == 'object') {
                        Object.keys(query[key]).forEach(subKey => {
                            if (usedLandingPage.query[key].indexOf(query[key][subKey]) === -1) {
                                if (typeof optimizedQuery[key] == 'undefined') {
                                    optimizedQuery[key] = [];
                                }
                                optimizedQuery[key].push(query[key][subKey]);
                            }
                        });
                        return;
                    }
                    // If we get here then somehow the key should be an array but the query isn't an array. Something's definitely gone wrong
                    optimizedQuery[key] = query[key];
                    return;
                }

                if (query[key] != usedLandingPage.query[key]) {
                    optimizedQuery[key] = query[key];
                }
            });
            if (usedLandingPage.manufacturer_slug != '') {
                return {
                    name: 'branded-cms-landing-page',
                    params: {
                        brand: usedLandingPage.manufacturer_slug,
                        slug: usedLandingPage.slug
                    },
                    query: optimizedQuery,
                };
            }
            return {
                name: 'cms-landing-page',
                params: {
                    slug: usedLandingPage.slug
                },
                query: optimizedQuery,
            };
        }
    }

    if ((query.nearlyNew && query.nearlyNew == '1') || (meta.nearlyNew && meta.nearlyNew == 1)) {
        if (query.manufacturer) {
            const brandFromManufacturer = GetBrandFromManufacturer(query.manufacturer);
            if (brandFromManufacturer !== 'randd') {
                return {
                    name: 'branded-used-results',
                    params: {
                        brand: brandFromManufacturer,
                        resultsType: 'nearly-new'
                    },
                    query: query,
                };
            }
        }
        if (to.params && to.params.brand) {
            if (to.params.brand !== 'randd') {
                return {
                    name: 'branded-used-results',
                    params: {
                        brand: to.params.brand,
                        resultsType: 'nearly-new'
                    },
                    query: query,
                };
            }
        }
        return {
            name: 'used-results',
            params: {
                resultsType: 'nearly-new'
            },
            query: query,
        };
    }

    if ((query.specialOffer && query.specialOffer == '1') || (meta.specialOffer && meta.specialOffer == 1)) {
        if (query.manufacturer) {
            const brandFromManufacturer = GetBrandFromManufacturer(query.manufacturer);
            if (query.manufacturer !== 'randd') {
                return {
                    name: 'branded-used-results',
                    params: {
                        brand: brandFromManufacturer,
                        resultsType: 'used-special-offers'
                    },
                    query: query,
                };
            }
        }
        if (to.params && to.params.brand) {
            if (to.params.brand !== 'randd') {
                return {
                    name: 'branded-used-results',
                    params: {
                        brand: to.params.brand,
                        resultsType: 'used-special-offers'
                    },
                    query: query,
                };
            }
        }
        return {
            name: 'used-results',
            params: {
                resultsType: 'used-special-offers'
            },
            query: query,
        };
    }

    if (query.manufacturer) {
        if (query.manufacturer !== 'reset') {
            const brandFromManufacturer = GetBrandFromManufacturer(query.manufacturer);
            if (brandFromManufacturer !== 'randd') {
                return {
                    name: 'branded-used-results',
                    params: {
                        brand: brandFromManufacturer,
                        resultsType: 'used-vehicles'
                    },
                    query: query,
                };
            }
        } else {
            query.manufacturer = '';
        }
    } else if (to.params && to.params.brand) {
        if (to.params.brand !== 'randd') {
            return {
                name: 'branded-used-results',
                params: {
                    brand: to.params.brand,
                    resultsType: 'used-vehicles'
                },
                query: query,
            };
        }
    }

    return {
        name: 'used-results',
        params: {
            resultsType: 'used-vehicles'
        },
        query: query,
    };
}